import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/BecomeMemberDialog.css";
import { WEB_LINK } from "utils/strings";

interface JoinCircleDialogProps {
  open: boolean;
  onClose: () => void;
}

const JoinCircleDialog: React.FC<JoinCircleDialogProps> = ({
  open,
  onClose,
}) => {
  const handleJoinNowClick = () => {
      window.open(WEB_LINK.CONNECT_LINK, "_blank", "noopener,noreferrer");
      onClose();
    };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "become-member-dialog-container",
      }}
      BackdropProps={{
        className: "become-member-dialog-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="become-member-dialog-header">
          Step Into the Community ✨
        </div>
        <div className="become-member-dialog-divider"></div>
        <div className="become-member-dialog-containt-container">
          <p>
            Want to join ”The Foundry” community space and Connect with fellow
            Founders
          </p>
        </div>
        <div className="become-member-dialog-button" onClick={handleJoinNowClick}>
          <div>Join Now!</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default JoinCircleDialog;
